import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackAnnotationSizeChanged } from "@air/analytics";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
import { annotationSizes } from "~/components/AssetModal/AssetModalFooter/AnnotationsToggle/AnnotateUtilsPanel/shared/constants";
import { ANNOTATION_SIZE_SELECT } from "~/constants/testIDs";
export const AnnotationSizeSelect = /*#__PURE__*/ memo((param)=>{
    let { selectedSize, setSize } = param;
    const { trackAnnotationSizeChanged } = useTrackAnnotationSizeChanged();
    return /*#__PURE__*/ _jsx("div", {
        className: "mx-2 flex gap-0.5 py-2",
        children: annotationSizes.map((size)=>/*#__PURE__*/ _jsx(IconButton, {
                "data-testid": "".concat(ANNOTATION_SIZE_SELECT, "-").concat(size.width),
                appearance: selectedSize === size.width ? "filled" : "ghost",
                color: "grey",
                size: "small",
                icon: size.icon,
                onClick: (event)=>{
                    event.stopPropagation();
                    trackAnnotationSizeChanged({
                        size: size.width
                    });
                    setSize(size.width);
                },
                label: "Change size to ".concat(size.width)
            }, size.width))
    });
});
AnnotationSizeSelect.displayName = "AnnotationSizeSelect";
